import { render, staticRenderFns } from "./HCconsulta.vue?vue&type=template&id=650b8d9a"
import script from "./HCconsulta.vue?vue&type=script&lang=js"
export * from "./HCconsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports